import React from 'react';
import { Spinner } from 'src/components/spinner';
import * as S from './styles';
import { IconMagnifier } from '@prisjakt/ui/icon/magnifier';

type SearchProps = {
  className?: string;
  inputValue: string;
  onChange: (value: string) => void;
  onFocus: (value: string) => void;
  onBlur?: () => void;
  onSearch: (search: string) => void;
  hasResults?: boolean;
  placeholder?: string;
  setInputValue: (input: string) => void;
  isSearching?: boolean;
};

const Search = ({
  className,
  inputValue,
  onChange,
  onFocus,
  onBlur,
  onSearch,
  hasResults,
  placeholder,
  setInputValue,
  isSearching,
}: SearchProps) => {
  const clearInput = React.useCallback(() => {
    onChange('');
    setInputValue('');
  }, [onChange, setInputValue]);

  const onSearchButtonClick = React.useCallback(() => {
    onSearch(inputValue);
  }, [onSearch, inputValue]);

  const onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void =
    React.useCallback(
      ({ target }) => {
        onChange(target.value);
        setInputValue(target.value);
      },
      [onChange, setInputValue]
    );

  const handleFocus = React.useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      onFocus(e.target.value);
    },
    [onFocus]
  );

  return (
    <S.Block hasResults={hasResults} className={className}>
      <S.Input
        onChange={onInputChange}
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={onBlur}
      />
      <S.ClearButton type="button" visible={inputValue} onClick={clearInput}>
        <S.CloseIcon size={20} />
      </S.ClearButton>
      <S.FullSearchButton type="button" onClick={onSearchButtonClick}>
        {isSearching ? (
          <Spinner isActive={isSearching} position="none" />
        ) : (
          <IconMagnifier />
        )}
      </S.FullSearchButton>
    </S.Block>
  );
};

Search.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFocus: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSearch: () => {},
  hasResults: false,
  placeholder: undefined,
};

export default Search;
